// extracted by mini-css-extract-plugin
export default {"menuContent":"StatusPickerMenu-module__menuContent"};